/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует системные функции интеграции с IoT провайдерами
 */

/**
 * Сервис для системных функций интеграции с IoT провайдерами
 */
export class SystemServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод проверки доступности сервиса.
   * Не требует авторизации
   */
  GetPing = (req?: GetPingRequestDto, init?: RequestInit): Promise<GetPingResponseDto> => {
    return fm.request<GetPingRequestDto, GetPingResponseDto>(`${this.host}/iot_connect/api/v1/ping${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос доступности сервиса
 */
export type GetPingRequestDto = {
}
/**
 * Ответ на запрос доступности сервиса
 */
export type GetPingResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос доступности сервиса
   */
  "GetPingRequest": {
    "kind": "class",
    "text": "Запрос доступности сервиса",
  },
  /**
   * Ответ на запрос доступности сервиса
   */
  "GetPingResponse": {
    "kind": "class",
    "text": "Ответ на запрос доступности сервиса",
  },
}